import { render } from "./Header.vue?vue&type=template&id=712ce798&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=712ce798&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-712ce798"

export default script